<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col md="8" sm="8" xs="12">
                <v-card v-if="contacts"> 
                    <v-card-title class="px-3">Chargeback Contacts</v-card-title>
                    <v-divider></v-divider>

                    <!-- Transaction ID -->
                    <v-row align="center" justify="left">
                        <v-col md="3" justify="center" align="center" class="mx-4">
                            <v-text-field 
                                v-model="merchantName"
                                append-icon="mdi-magnify"
                                label="Merchant Name"
                                clearable
                                @change="getChargebackContacts"
                                @click:clear="merchantName = null; getChargebackContacts();"
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col align="end" justify="center" class="mx-4">
                            <v-btn
                                small
                                dark
                                color="primary"
                                @click="refresh"
                                ><v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col> -->
                    </v-row>

                    <v-divider></v-divider>

                    <!-- Table -->
                    <v-data-table
                        
                        :headers="headers"
                        :items="contacts"
                        :items-per-page="10"
                        class="elevation-1"
                    >
                        <template v-slot:item.contact="props">
                            <v-edit-dialog
                                :return-value.sync="props.item.contact"
                                @save="save"
                                @cancel="cancel"
                                @open="open(props.item)"
                                @close="close(props.item)"
                                single
                                >
                                <span class="primary--text text--darken-1">{{ props.item.contact }}</span>
                                <template v-slot:input>
                                    <v-text-field
                                        v-model="props.item.contact"
                                        label="Edit"
                                    ></v-text-field>
                                </template>
                            </v-edit-dialog>
                        </template>
                    </v-data-table>

                    <v-snackbar
                        v-model="snack"
                        timeout="3000"
                        color="primary"
                        bottom
                    >
                        {{ snackText }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                            dark
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                            >
                            Close
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    beforeMount() {
        this.getChargebackContacts();
    },
    data() {
        return {
            headers: [{ text: 'Merchant', value: 'merchantName', sortable: false},
                      { text: 'Acquirer', value: 'clearingInstitute', sortable: false },
                      { text: 'Contacts', value: 'contact', sortable: false },
                      { text: 'Date Created', value: 'createdAt', sortable: false }],
            contacts: [],
            snack: false,
            snackText: null,
            openContact: null,
            openContactId: null,
            merchantName: null
        }
    },
    methods: {
        getChargebackContacts() {
            axios({
                method: 'post',
                url: `get-chargeback-contacts`,
                data: { merchantName: this.merchantName },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.contacts = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        save() {
           
        },
        cancel() {
          
        },
        open(item) {
            this.openContact = item.contact;
            this.openContactId = item.id;
        },
        close(item) {
            if(this.openContact != item.contact && this.openContactId == item.id && item.contact.length) {
                axios({
                    method: 'post',
                    url: `edit-chargeback-contact`,
                    data: item,
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.snackText = `Successfully updated contact for ${item.merchantName}`;
                        this.snack = true;
                        item.createdAt = moment().format('YYYY-MM-DD HH:mm:ss');
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
        },
    }
}
</script>